import {
  SorterCategory,
  SorterItem
} from '../../../models/LessonComponentContent';

import Box from '@mui/material/Box';
import DeleteIcon from '@mui/icons-material/Delete';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Unstable_Grid2';
import { IconButtonWithConfirmation } from '../../../../shared/components/IconButtonWithConfirmation';
import { InlineTextEdit } from '../../InlineTextEdit';
import React from 'react';
import { SorterItemEditor } from './SorterItemEditor';
import componentStyles from '../../../styles/LessonComponents.module.css';
import { isEmpty } from 'lodash';
import styles from '../../../styles/Sorter.module.css';

interface SorterCategoryEditorProps {
  categories: SorterCategory[];
  onDeleteCategory: (value: string) => void;
  onSaveCategoryLabel: (categoryValue: string, label: string) => void;
  onDeleteItem: (categoryValue: string, itemValue: string) => void;
  onSaveItem: (categoryValue: string, item: SorterItem) => void;
}

export function SorterCategoryEditor(props: SorterCategoryEditorProps) {
  function handleSaveCategoryLabel(categoryValue: string, label: string) {
    props.onSaveCategoryLabel(categoryValue, label);
  }

  function handleDeleteCategory(value: string) {
    props.onDeleteCategory(value);
  }

  function handleDeleteItem(categoryValue: string, itemValue: string) {
    props.onDeleteItem(categoryValue, itemValue);
  }

  function handleSaveItem(categoryValue: string, item: SorterItem) {
    props.onSaveItem(categoryValue, item);
  }

  return (
    <div className={styles.categoryList}>
      {props.categories.map((category) => (
        <Grid
          key={category.id}
          container
          direction="column"
          className={styles.category}
        >
          <Grid>
            <Grid container alignItems="center">
              <Grid>
                <FormControl component="fieldset">
                  <Box className={componentStyles.textOverflow}>
                    <FormLabel component="legend">
                      <InlineTextEdit
                        value={category.label}
                        style={{ fontSize: '14px', display: 'block' }}
                        placeholder="Click to edit category name"
                        onChange={(value) =>
                          handleSaveCategoryLabel(category.id, value)
                        }
                      />
                    </FormLabel>
                  </Box>
                </FormControl>
              </Grid>
              <Grid>
                <IconButtonWithConfirmation
                  size="small"
                  disable={props.categories.length < 3}
                  onConfirm={() => handleDeleteCategory(category.id)}
                >
                  <DeleteIcon />
                </IconButtonWithConfirmation>
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            <Grid container direction="column" spacing={1}>
              {category.items.map((item) => (
                <Grid key={item.id}>
                  <Grid container alignItems="center">
                    <Grid className={styles.gridStretch}>
                      <SorterItemEditor
                        item={item}
                        onSave={(item) => handleSaveItem(category.id, item)}
                      />
                    </Grid>
                    <Grid>
                      <IconButtonWithConfirmation
                        size="small"
                        disable={category.items.length < 2}
                        onConfirm={() => handleDeleteItem(category.id, item.id)}
                      >
                        <DeleteIcon />
                      </IconButtonWithConfirmation>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
              {/* Not allowed to add a new item until category label is set when there are no items. */}
              {(!isEmpty(category.label) || !isEmpty(category.items)) && (
                <Grid className={styles.sorterNewItem}>
                  <SorterItemEditor
                    onSave={(item) => handleSaveItem(category.id, item)}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      ))}
    </div>
  );
}
